import { GzRangeSliderInputWebComponent } from './component/GzRangeSliderInputWebComponent';
import { WEB_COMPONENT_GZ_RANGE_SLIDER_INPUT } from '../../webcomponents.constants';

export { GzRangeSliderInputWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_RANGE_SLIDER_INPUT, GzRangeSliderInputWebComponent);
